export { default } from './ContentCard';
